import moment from 'moment';
import mTimezone from 'moment-timezone';

export const fullDay = 86400000;
export const timeGrid = 1800000;

export const format = time => moment(time).format('DD.MM.YYYY HH:mm:ss');

export const formatDate = date => moment(date).format('ddd DD.MM');

export const formatTZ = (time, timezone) =>
	`${mTimezone(time).tz(timezone).format('HH:mmZZ')}`;

export const formatNoTZ = (time, timezone) =>
	`${mTimezone(time).tz(timezone).format('HH:mm')}`;

export const formatDateTZ = (time, timezone) =>
	`${mTimezone(time).tz(timezone).format('DD.MM HH:mmZZ')}`;

export const formatDateNoTZ = (time, timezone) =>
	`${mTimezone(time).tz(timezone).format('DD.MM HH:mm')}`;

export const getOffset = (time, timezone) => {
	const when = mTimezone(time).tz(timezone);
	const hour = when.hour();
	const minutes = when.minutes();

	return (hour - 8) * 2 + minutes / 30;
};

export const formatUnixTZ = (time, timezone) =>
	`${mTimezone(time).tz(timezone).format('DD.MM HH:mm ZZ')}`;

export const formatSQLTZ = (time, timezone) =>
	`${mTimezone(time).tz(timezone).format('YYYY-MM-DD HH:mm:ssZZ')}`;

export const getDateTabs = tz => (acc, cons) => {
	const { starts_at } = cons;
	const date = mTimezone(starts_at).tz(tz).format('YYYY-MM-DD');
	if (typeof acc[date] === 'undefined') acc[date] = [];
	acc[date].push(cons);

	return acc;
};

export const getZZ = timezone => mTimezone.tz(timezone).format('ZZ');

export const getTime = (date, time, timezone) =>
	mTimezone(`${date} ${time} ${getZZ(timezone)}`, 'YYYY-MM-DD HH:mm ZZ')
		.toDate()
		.getTime();

export const getSlotUnix = (monday, day, slot) =>
	monday + day * fullDay + (16 + slot) * timeGrid;

export const getSQLTime = sqlTime =>
	mTimezone(sqlTime, 'YYYY-MM-DD HH:mm:ssZZ').toDate().getTime();

export const getAge = birthDate => {
	if (!moment(birthDate).isValid()) return '';
	return moment().diff(birthDate, 'years');
};

export const invalid = (date, time) => !moment(`${date} ${time}`).isValid();

export const range = n => Array.from(Array(n).keys());

export const getHour = (time, timezone) =>
	mTimezone(time).tz(timezone).format('HH:mm');

export const getWeekTimezone = time =>
	mTimezone(time).tz('Canada/Atlantic').isDST() ? 'Etc/GMT+4' : 'Etc/GMT+5';

export const applyWeekOffset = (time, weekOffset) =>
	time + 7 * weekOffset * fullDay;

export const getTimezoneByWeekOffset = weekOffset => {
	const now = moment().toDate().getTime();
	const withOffset = applyWeekOffset(now, weekOffset);
	return getWeekTimezone(withOffset);
};

export const getMondayByWeekOffset = weekOffset => {
	const now = moment().toDate().getTime();
	const withOffset = applyWeekOffset(now, weekOffset);
	const timezone = getWeekTimezone(withOffset)
	return mTimezone(withOffset).tz(timezone).weekday(1).startOf('day').toDate().getTime();
}

export const getMonday = timezone =>
	mTimezone().tz(timezone).weekday(1).startOf('day').toDate().getTime();

export const getWeek = monday => {
	const weekTitle = `${moment(monday).format('DD.MM')}–${moment(
		monday + 6 * fullDay
	).format('DD.MM')}`;
	const week = range(7).map(
		i => moment(monday + i * fullDay) //.format('dd DD.MM')
	);
	return [weekTitle, week];
};
